import { render, staticRenderFns } from "./voucher-sale-confirmation.vue?vue&type=template&id=832f6ffe&scoped=true&"
import script from "./voucher-sale-confirmation.vue?vue&type=script&lang=js&"
export * from "./voucher-sale-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./voucher-sale-confirmation.vue?vue&type=style&index=0&id=832f6ffe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832f6ffe",
  null
  
)

export default component.exports